import { Inject, Injectable } from "@angular/core";
import { AppType, APP_TYPE } from "../../app.type";
import { OCCommentServiceType } from "./OC-comment.service.type";
import { OCComment } from "../../../../../shared/models/obsolescence-community/OC-Comment";
import { ocCommentsByPostId, saveOCComment } from "../../../app/api.service";
import { hasChanges } from "../../utils/app.utils";

@Injectable()
export class OCCommentService implements OCCommentServiceType {
  constructor(@Inject(APP_TYPE) private app: AppType) {}
  commentDoc: OCComment = new OCComment();
  selectedComment: OCComment = new OCComment();
  cleanComment: OCComment = new OCComment();
  comments: OCComment[] = [];

  async saveComment() {
    this.app.spinner.showSpinner();
    this.commentDoc = this.app.post.setCreditsOnPost(this.commentDoc);
    await saveOCComment(
      this.app.customers.expectCurrent,
      this.commentDoc,
      this.app.OCPost.selectedPost._id
    );

    this.app.OCHome.pageNumber = 1;
    await this.app.OCHome.updateOCPosts();

    // Reset Model
    this.commentDoc = new OCComment();
    await this.ocCommentsByPostId();
    this.app.spinner.hideSpinner();
  }

  async updateComment() {
    this.app.spinner.showSpinner();
    if (this.app.state.userId != null) {
      this.cleanComment = this.app.post.setCreditsOnPost(
        this.cleanComment,
        this.app.state.userId
      );
    }
    await saveOCComment(
      this.app.customers.expectCurrent,
      this.cleanComment,
      this.app.OCPost.selectedPost._id
    );

    this.app.OCHome.pageNumber = 1;

    if (this.app.OCHome.isFilterSelected) {
      await this.app.OCHome.filterOCPosts(
        this.app.OCHome.selectedType,
        this.app.OCHome.searchWords[this.app.OCHome.selectedType]
      );
    }

    await this.ocCommentsByPostId();
    this.app.OCHome.editedId = "";
    this.app.spinner.hideSpinner();
  }

  async deleteComment(selectedComment: any) {
    this.app.spinner.showSpinner();
    // Delete selected comment
    selectedComment._deleted = true;
    await saveOCComment(
      this.app.customers.expectCurrent,
      selectedComment,
      this.app.OCPost.selectedPost._id
    );

    this.app.OCHome.pageNumber = 1;
    await this.app.OCHome.updateOCPosts();
    await this.ocCommentsByPostId();
    this.app.spinner.hideSpinner();
  }

  async ocCommentsByPostId() {
    if (this.app.OCPost.selectedPost != null) {
      this.comments = await ocCommentsByPostId(
        this.app.customers.expectCurrent,
        this.app.OCPost.selectedPost._id
      );
    }
    this.app.table.sort(this.comments, "ocComment");

    return this.comments;
  }

  modelHasChanges() {
    const modelHasChanges = hasChanges(this.cleanComment, this.selectedComment);
    if (this.cleanComment["message"] != "" && modelHasChanges) {
      return false;
    } else {
      return true;
    }
  }

  discardChanges() {
    this.app.OCHome.editedId = "";
  }
}
